import { INVALIDATE_FLOW_VARIABLES, SET_FLOW_VARIABLES, SET_FLOW_VARIABLES_LOADING } from '../types';

const initialState = {
  flowId: null,
  variables: [],
  needsRefresh: false,
  isLoading: false,
};

const flowVariables = (state = initialState, action) => {
  switch (action.type) {
    case SET_FLOW_VARIABLES:
      return {
        flowId: action.payload.flowId,
        variables: action.payload.variables ?? [],
        needsRefresh: false,
        isLoading: false,
      };
    case INVALIDATE_FLOW_VARIABLES: {
      const targetFlowId = action.payload ?? state.flowId;

      return {
        flowId: targetFlowId,
        variables:
          targetFlowId === state.flowId
            ? state.variables
            : [],
        needsRefresh: true,
        isLoading: false,
      };
    }
    case SET_FLOW_VARIABLES_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    default:
      return state;
  }
};

export default flowVariables;
